export const profilevalidationmsgs = [
  {
    AssignedComponent: {
      link: '#',
      title: 'Select a valid Assigned Component',
    },

    DoDNumber: {
      link: '#',
      title: 'Enter valid DoD ID Number',
    },

    DutyEmail: {
      link: '#',
      title: 'Enter valid Duty Email',
    },
    DutyPhone: {
      link: '#',
      title: 'Enter valid Duty Phone Number',
    },
    Installation: {
      link: '#',
      title: 'Enter valid Assigned Location',
    },
    Organization: {
      link: '#',
      title: 'Enter valid Organization',
    },
    PASCODE: {
      link: '#',
      title: 'Enter valid Pascode',
    },
    PersonalEmail: {
      link: '#',
      title: 'Enter valid Personal Email',
    },
    PersonalPhone: {
      link: '#',
      title: 'Enter valid Personal Phone Number',
    },
    ProfileStatus: {
      link: '#',
      title: 'Select a valid Status',
    },
    Rank: {
      link: '#',
      title: 'Select a valid Rank',
    },
    ServicingMAJCOM: {
      link: '#',
      title: 'Select a valid Servicing MAJCOM',
    },
  },
]
